/* eslint-disable max-lines */
export const configData = [
  {
    type: 'text',
    code: 'customer_name_qu4p83wxh',
    hint: 'Customer Name',
    required: false,
    read_only: false,
    display_in_form_type: 'MODULE',
    tooltip: 'Customer Name Tooltip',
    oif_options: {
      type: 'default',
      url: '/validation/validateEntity',
      params: [
        {
          code: 'customer_name_qu4p83wxh',
          name: 'customer_name_qu4p83wxh',
        },
      ],
    },
  },
  {
    type: 'date_range_v2',
    code: 'last_update_date',
    hint: 'Last Updated Date',
    value: {
      start: '1760102289000',
      end: '1760113089000',
      type: 'custom',
    },
  },
  {
    type: 'aif',
    code: 'transaction_mode_aif',
    required: true,
    hint: 'Transaction Mode AIF',
    value: [],
    group_title: 'Transaction',
    add_action_title: 'Add Transaction',
    tooltip: 'Transaction Mode AIF Tooltip',
    min_group: 1,
    max_group: 5,
    input_fields: [
      {
        type: 'text',
        code: 'aif1',
        hint: 'Transaction Code',
        required: true,
        oif_options: null,
        read_only: false,
        display_in_form_type: 'MODULE',
      },
      {
        type: 'text',
        code: 'aif2',
        hint: 'Transaction name',
        required: false,
        oif_options: null,
        read_only: false,
        display_in_form_type: 'MODULE',
      },
      {
        type: 'text',
        code: 'aif3',
        hint: 'Transaction desc',
        required: true,
        oif_options: null,
        read_only: false,
        display_in_form_type: 'MODULE',
      },
    ],
    oif_options: {
      type: 'default',
    },
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'text',
    code: 'context_input',
    hint: 'Input for Context Filter Value',
    required: false,
    read_only: false,
  },
  {
    type: 'referral',
    code: 'calendar_complete',
    hint: 'Calendar Complete Input',
    source: 'loan_new',
    async: false,
    required: true,
    online: true,
    read_only: false,
    context_filters: [
      {
        code: 'calendar_complete',
        source_context: 'referral',
        source_filter_code: 'context_input',
        type: 'dynamic',
        source_namespace: 'form',
        filter_attribute: 'current_bucket_l0km2ea6fg',
        source_attribute: 'context_input',
      },
    ],
    referred_field: 'code',
    display_in_form_type: 'MODULE',
  },
  {
    type: 'code_name_spinner',
    code: 'context_filter_dropdown',
    hint: 'Dropdown with context filter',
    required: false,
    min_chars: null,
    max_chars: null,
    regex: null,
    regex_hint: null,
    parent_code: null,
    read_only: false,
    retain_form_context: false,
    context_filters: [
      {
        code: 'context_filter_dropdown',
        source_context: 'form',
        source_filter_code: 'context_input',
        type: 'dynamic',
        source_namespace: 'form',
        filter_attribute: 'code',
        source_attribute: 'context_input',
      },
    ],
    code_name_spinner_options: [
      {
        code: 'none',
        name: 'None',
      },
      {
        code: 'a',
        name: 'A',
      },
      {
        code: 'b',
        name: 'B',
      },
      {
        code: 'c',
        name: 'C',
      },
      {
        code: 'd',
        name: 'D',
      },
    ],
    duration_optional: true,
    show_location: false,
    default_millies_from_now: 0,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'number',
    code: 'gst_number_0amsodvw1e',
    hint: 'GST Number',
    required: false,
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'radio',
    code: 'test_radio',
    hint: 'Test Radio',
    meta: {
      viewType: 'radio',
    },
    options: [
      { name: 'Option 1', code: 'option1' },
      { name: 'Option 2', code: 'option2', disabled: true },
      { name: 'Option 3', code: 'option3' },
    ],
    required: false,
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'radio',
    code: 'test_radio3',
    hint: 'Test Radio with Options more than 4',
    meta: {
      viewType: 'chipRadio',
    },
    options: [
      { name: 'Option 1', code: 'option1' },
      { name: 'Option 2', code: 'option2', disabled: true },
      { name: 'Option 3', code: 'option3' },
      { name: 'Option 4', code: 'option4' },
      { name: 'Option 5', code: 'option5' },
    ],
    required: false,
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'radio',
    code: 'test_radio2',
    hint: 'Test Radio 2',
    meta: {
      viewType: 'chipRadio',
    },
    options: [
      { name: 'Option 1', code: 'option1' },
      { name: 'Option 2', code: 'option2', disabled: true },
      { name: 'Option 3', code: 'option3' },
    ],
    required: false,
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'sifg',
    code: 'sifg_payment_mode_chw0gfq6vo',
    required: true,
    hint: 'Payment Mode',
    value: 'Cash',
    sifg_options: {
      selection: {
        type: 'code_name_spinner',
        code: 'payment_mode_chw0gfq6vo',
        hint: 'Payment Mode',
        code_name_spinner_options: [
          {
            code: 'none',
            name: 'Select',
            order: 0,
          },
          {
            code: 'Cheque',
            name: 'Cheque',
          },
          {
            code: 'DD',
            name: 'DD',
          },
        ],
        required: true,
      },
      inputs: {
        Cash: [],
        Cheque: [
          {
            type: 'date',
            code: 'cheque_dd_date_ru6jxvvlh',
            hint: 'Cheque/DD Date',
            required: true,
            show_day_month_year: 'DMY',
            min_date: 0,
            max_date: 0,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'cheque_dd_no_ce29164mpp',
            hint: 'Cheque/DD No',
            required: true,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'micr_code_676weuw8i7',
            hint: 'MICR Code',
            required: false,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'bank_name_8gcf8bmd9c',
            hint: 'Bank Name',
            required: true,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
        DD: [
          {
            type: 'date',
            code: 'cheque_dd_date_ru6jxvvlh',
            hint: 'Cheque/DD Date',
            required: true,
            show_day_month_year: 'DMY',
            min_date: 0,
            max_date: 0,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'cheque_dd_no_ce29164mpp',
            hint: 'Cheque/DD No',
            required: true,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'micr_code_676weuw8i7',
            hint: 'MICR Code',
            required: false,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
          {
            type: 'text',
            code: 'bank_name_8gcf8bmd9c',
            hint: 'Bank Name',
            required: true,
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
      },
    },
    oif_options: {
      type: 'default',
    },
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'sifg',
    code: 'sifg_payee_type_gpu8wmbsa',
    required: true,
    hint: 'Payee Type',
    sifg_options: {
      selection: {
        type: 'code_name_spinner',
        code: 'payee_type_gpu8wmbsa',
        hint: 'Payee Type',
        code_name_spinner_options: [
          {
            code: 'none',
            name: 'Select',
            order: 0,
          },
          {
            code: 'Customer',
            name: 'Customer',
          },
          {
            code: 'Spouse',
            name: 'Spouse',
          },
          {
            code: 'Mother',
            name: 'Mother',
          },
          {
            code: 'Father',
            name: 'Father',
          },
          {
            code: 'Brother',
            name: 'Brother',
          },
          {
            code: 'Sister',
            name: 'Sister',
          },
        ],
        required: true,
      },
      inputs: {
        Customer: [],
        Relative: [],
        Self: [],
        Spouse: [
          {
            type: 'sifg',
            code: 'sifg_leadsourcetpd_aoc6apz8nh',
            required: true,
            hint: 'Lead Source',
            sifg_options: {
              selection: {
                type: 'code_name_spinner',
                code: 'leadsourcetpd_aoc6apz8nh',
                hint: 'Lead Source',
                code_name_spinner_options: [
                  {
                    code: 'none',
                    name: 'Select',
                    order: 0,
                  },
                  {
                    code: 'self_sourced',
                    name: 'Self Sourced',
                    order: 1,
                  },
                  {
                    code: 'branch_walk',
                    name: 'Branch Walk-in',
                    order: 2,
                  },
                  {
                    code: 'branch_manager',
                    name: 'Branch Manager',
                    order: 3,
                  },
                  {
                    code: 'other',
                    name: 'Other',
                    order: 4,
                  },
                ],
                required: true,
              },
              inputs: {
                self_sourced: [],
                branch_walk: [],
                branch_manager: [],
                branch_banking: [],
                operations: [],
                synergy: [],
                other: [
                  {
                    type: 'text',
                    code: 'sharedetails_nzixc1j1k8',
                    hint: 'Share details',
                    required: true,
                    read_only: false,
                    retain_form_context: false,
                    display_in_form_type: 'MODULE',
                    search_options: null,
                  },
                ],
              },
            },
            oif_options: {
              type: 'default',
            },
            read_only: false,
            retain_form_context: false,
            display_in_form_type: 'MODULE',
            search_options: null,
            value: 'other',
          },
        ],
        Mother: [
          {
            type: 'text',
            code: 'payeee_name__yty9vxu8j',
            hint: 'Payee name',
            required: true,
            regex: '^[A-Za-z]+[A-Za-z ]*$',
            regex_hint: 'Please input correct name',
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
        Father: [
          {
            type: 'text',
            code: 'payeee_name__yty9vxu8j',
            hint: 'Payee name',
            required: true,
            regex: '^[A-Za-z]+[A-Za-z ]*$',
            regex_hint: 'Please input correct name',
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
        Brother: [
          {
            type: 'text',
            code: 'payeee_name__yty9vxu8j',
            hint: 'Payee name',
            required: true,
            regex: '^[A-Za-z]+[A-Za-z ]*$',
            regex_hint: 'Please input correct name',
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
        Sister: [
          {
            type: 'text',
            code: 'payeee_name__yty9vxu8j',
            hint: 'Payee name',
            required: true,
            regex: '^[A-Za-z]+[A-Za-z ]*$',
            regex_hint: 'Please input correct name',
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
        Other: [
          {
            type: 'text',
            code: 'payeee_name__yty9vxu8j',
            hint: 'Payee name',
            required: true,
            regex: '^[A-Za-z]+[A-Za-z ]*$',
            regex_hint: 'Please input correct name',
            oif_options: null,
            read_only: false,
            display_in_form_type: 'MODULE',
          },
        ],
      },
    },
    oif_options: {
      type: 'default',
      url: '/validation/validateEntity',
      params: [
        {
          code: 'sifg_payee_type_gpu8wmbsa',
          name: 'sifg_payee_type_gpu8wmbsa',
        },
      ],
    },
    read_only: false,
    display_in_form_type: 'MODULE',
  },
  {
    type: 'text',
    code: 'referral_ff_input',
    hint: 'Referral Context Input',
    oif_options: null,
    required: false,
    read_only: false,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'vo-referral',
            operator_required: false,
            attribute: 'campaign_filter',
            input_field: 'campaign_filter',
            vo_id: 'calendar_complete',
          },
        },
      ],
      standard_function: 'IS',
      return_type: 'text',
    },
  },
  {
    type: 'text',
    code: 'session_context_input',
    hint: 'Session Context Input',
    required: false,
    read_only: false,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'session',
            operator_required: false,
            attribute: 'attributes.name',
            input_field: 'if_name',
          },
        },
      ],
      standard_function: 'IS',
      return_type: 'text',
    },
  },
  {
    type: 'text',
    code: 'input_a',
    hint: 'Input A',
    required: false,
    read_only: false,
  },
  {
    type: 'text',
    code: 'input_b',
    hint: 'Input B Data would be equla to input a',
    required: false,
    read_only: false,
    default_value: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator_required: false,
            attribute: 'input_a',
            input_field: 'input_a',
          },
        },
      ],
      standard_function: 'IS',
      return_type: 'text',
    },
  },
  {
    type: 'text',
    code: 'input_d',
    hint: 'Input D would hide if "input a" value is not empty',
    required: false,
    read_only: false,
    hiddenV2: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'form',
            operator_required: false,
            attribute: 'input_a',
            input_field: 'input_a',
          },
        },
      ],
      standard_function: 'IS_NOT_EMPTY',
      return_type: 'text',
    },
  },
  {
    type: 'date',
    code: 'dob_19mar_3dat6eo56r',
    hint: 'Date check with min max',
    required: false,
    show_day_month_year: 'DMY',
    min_date: -3155760000000,
    max_date: 86400000,
    oif_options: null,
    read_only: false,
    retain_form_context: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'meeting',
    code: 'meet_19mar_8ia9t7zqyq',
    hint: 'meet 19mar Edit01',
    required: false,
    min_chars: null,
    max_chars: null,
    regex: null,
    regex_hint: null,
    parent_code: null,
    read_only: false,
    retain_form_context: false,
    code_name_spinner_options: [
      {
        code: 'none',
        name: 'Duration',
      },
      {
        code: '300000',
        name: '5 mins',
      },
      {
        code: '1800000',
        name: '30 mins',
      },
      {
        code: '3600000',
        name: '60 mins',
      },
      {
        code: '5400000',
        name: '90 mins',
      },
    ],
    duration_optional: true,
    show_location: false,
    default_millies_from_now: 0,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'time',
    code: 'time_19mar_gzgfe82ywi',
    hint: 'time 19mar Edit01',
    required: false,
    read_only: false,
    retain_form_context: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'text',
    code: 'input_c',
    hint: 'Input C (Validations on other field)',
    required: false,
    read_only: false,
    validations: [
      {
        expression: {
          type: 'standard',
          inputs: [
            {
              type: 'value',
              value: {
                val_type: 'form',
                operator_required: false,
                attribute: 'input_a',
                input_field: 'input_a',
              },
            },
          ],
          standard_function: 'IS_EMPTY',
          return_type: 'bool',
        },
        error_message: 'Input A is mandatory.',
        disable_backend_validation: false,
      },
    ],
  },
  {
    type: 'number',
    code: 'mob',
    hint: 'Months on Book (Validations on Self)',
    required: false,
    read_only: false,
    validations: [
      {
        expression: {
          type: 'standard',
          inputs: [
            {
              type: 'value',
              value: {
                val_type: 'form',
                operator_required: false,
                attribute: 'mob',
                input_field: 'mob',
              },
            },
            {
              type: 'value',
              value: {
                val_type: 'static',
                // eslint-disable-next-line max-lines
                operator_required: false,
                value: 6,
                data_type: 'decimal',
              },
            },
          ],
          standard_function: 'LT',
          return_type: 'bool',
        },
        error_message: 'There is a validation of less than 6 months',
        disable_backend_validation: false,
      },
    ],
  },
  {
    type: 'date',
    code: 'date_19mar_6odq633dvp',
    hint: 'Date with min max 0',
    required: false,
    show_day_month_year: 'DMY',
    min_date: 0,
    max_date: 0,
    read_only: false,
    retain_form_context: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },

  {
    type: 'code_name_spinner',
    code: 'state_master_19mar_zxvk4wx4xf',
    hint: 'state master 19mar Edit01',
    code_name_spinner_options: [
      {
        code: 'KL7',
        name: 'Kerala7',
      },
      {
        code: 'KL70',
        name: 'Kerala70',
      },
      {
        code: 'KL71',
        name: 'Kerala71',
      },
      {
        code: 'KL72',
        name: 'Kerala72',
      },
      {
        code: 'KL73',
        name: 'Kerala73',
      },
      {
        code: 'KL74',
        name: 'Kerala74',
      },
      {
        code: 'KL75',
        name: 'Kerala75',
      },
      {
        code: 'KL76',
        name: 'Kerala76',
      },
      {
        code: 'KL77',
        name: 'Kerala77',
      },
      {
        code: 'KL78',
        name: 'Kerala78',
      },

      {
        code: 'TN',
        name: 'Tamil nadu',
      },
    ],
    required: false,
    oif_options: {
      url: '/bo/masters/lookup/state/test_ch1_qg9blf-prospective_agent_4rz19h_new/state_master_19mar_zxvk4wx4xf',
      params: [
        {
          code: 'state_master_19mar_zxvk4wx4xf',
          name: 'state_master_19mar_zxvk4wx4xf',
        },
        {},
      ],
    },
    read_only: false,
    retain_form_context: false,
    hidden: true,
    is_bo_field: true,
    bo_cns_code_field: 'state_code_uhl7nds11q',
    bo_cns_name_field: 'state_name_nz2wssk2hd',
    bo_definition_id: 'state_masters',
    return_fields: [
      {
        fields: ['city_master_19mar_3b3dq1skr'],
        filters: [{}],
      },
    ],
    display_in_form_type: 'MODULE',
    search_options: null,
  },

  {
    type: 'spinner',
    code: 'marital_status',
    required: false,
    source: null,
    hint: 'Marital Status',
    placeholder: null,
    invisible: false,
    oifOptions: {
      type: 'default',
    },
    read_only: false,
    retain_form_context: false,
    hidden: false,
    $resourceStrings: null,
    options: [
      'Select marital status',
      'Single',
      'Married',
      'Divorced',
      'Widowed',
    ],
  },
  {
    type: 'meeting',
    code: 'meeting',
    hint: 'Follow-up date edit19mar',
    required: true,
    min_chars: null,
    max_chars: null,
    regex: null,
    regex_hint: null,
    parent_code: null,
    read_only: false,
    retain_form_context: false,
    code_name_spinner_options: [
      {
        code: 'none',
        name: 'Duration',
      },
      {
        code: '300000',
        name: '5 mins',
      },
      {
        code: '1800000',
        name: '30 mins',
      },
      {
        code: '3600000',
        name: '60 mins',
      },
      {
        code: '5400000',
        name: '90 mins',
      },
    ],
    min_date: -50371200,
    max_date: 1000,
    duration_optional: true,
    show_location: false,
    default_millies_from_now: 0,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'sentence',
    code: 'testingsentence_31hrda0rso',
    hint: 'testingsentence',
    required: false,
    min_lines: 3,
    oif_options: null,
    read_only: false,
    validations: [
      {
        regex: /^[a-zA-Z\s]+$/,
        errorMessage: 'Only alphabets and spaces are allowed',
      },
    ],
  },
  {
    type: 'decimal',
    code: 'testingdecimal_c2vi4lxys8',
    hint: 'testingdecimal',
    required: false,
    oif_options: null,
    read_only: false,
  },
  {
    type: 'currency',
    code: 'testingcurrency_p79ec3vkpj',
    hint: 'testingcurrency',
    required: false,
    max_chars: 19,
    oif_options: null,
    read_only: false,
  },
  {
    type: 'email',
    code: 'testingemail_hs7o4emv7',
    hint: 'testingemail',
    required: false,
    read_only: false,
  },
  {
    type: 'number',
    code: 'testing_pincode_d9sestkwns',
    hint: 'testing Pincode',
    required: false,
    min_chars: 6,
    max_chars: 6,
    read_only: false,
  },
  {
    type: 'phone',
    code: 'phone',
    hint: 'Mobile Number',
    required: true,
    min_chars: 10,
    max_chars: 30,
    regex: '^.{5,10}$',
    regex_hint: 'Please add digit only',
    oif_options: null,
    tags: ['phone_primary'],
    read_only: false,
    retain_form_context: false,
    enable_country_code: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  { code: 'location', hint: 'Location', type: 'location', read_only: false },
  { code: 'aadahr', hint: 'A Location', type: 'aadhar' },
  {
    code: 'pan',
    hint: 'PAN',
    type: 'pan',
    defaultValue: {
      type: 'standard',
      inputs: [
        {
          type: 'value',
          value: {
            val_type: 'vo',
            operator_required: false,
            attribute: 'test',
          },
        },
      ],
      standard_function: 'IS',
      return_type: 'text',
    },
  },
  {
    type: 'label',
    code: 'simple_label',
    hint: 'Simple Label',
    value: 'Test Label',
  },
  {
    type: 'label',
    hint: 'Label with Link',
    code: 'link_label',
    value: 'Testing Yahoo: <a href="http://yahoo.com">Yahoo</a>',
  },
  {
    type: 'link',
    hint: 'Simple Link',
    title: 'Yahoo',
    code: 'simple_link',
    url: 'http://yahoo.com',
    show_link_icon: false,
  },
  {
    type: 'link',
    hint: 'Simple Link',
    title: 'Yahoo',
    code: 'simple_link_2',
    url: 'http://yahoo.com',
    show_link_icon: true,
  },
  {
    type: 'multimedia',
    code: 'testingmultimedia_cz94rd6r8o',
    required: false,
    hint: 'testingmultimedia',
    multimedia_options: {
      media_type: 'document',
      media_types: ['document', 'photo'],
      mime_types: [
        'application/pdf',
        'application/msword',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-powerpoint',
        'image/jpeg',
        'image/png',
        'image/jpeg',
        'image/heif',
        'image/hcif',
        'image/svg',
        'image/doc',
        'image/docx',
      ],
      access: ['local_storage', 'camera', 'gallery'],
      min_files: 0,
      max_files: 4,
    },
    oif_options: null,
    read_only: false,
    retain_form_context: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'multi_select_auto_complete',
    code: 'testmultisleect_8jdyxljf96',
    hint: 'testMultisleect',
    required: false,
    single_select: false,
    code_name_spinner_options: [
      {
        code: 'option_1',
        name: 'Option_1',
      },
      {
        code: 'mumjqcwb',
        name: 'MuMjqCwB',
      },
      {
        code: 'mrecvakl',
        name: 'MRecvAKl',
      },
      {
        code: 'option_2',
        name: 'Option_2',
      },
      {
        code: 'mumjqcwb1',
        name: 'MuMjqCwB1',
      },
      {
        code: 'mrecvakl2',
        name: 'MRecvAKl2',
      },
      {
        code: 'option_3',
        name: 'Option_3',
      },
      {
        code: 'mumjqcwb3',
        name: 'MuMjqCwB3',
      },
      {
        code: 'mrecvakl3',
        name: 'MRecvAKl3',
      },
      {
        code: 'option_4',
        name: 'Option_4',
      },
      {
        code: 'mumjqcwb4',
        name: 'MuMjqCwB4',
      },
      {
        code: 'mrecvakl4',
        name: 'MRecvAKl4',
      },
    ],
    oif_options: {
      type: 'default',
    },
    read_only: false,
    retain_form_context: false,
    display_in_form_type: 'MODULE',
    search_options: null,
  },
  {
    type: 'multimedia',
    code: 'upload_photo',
    name: 'Photo Proof',
    follow_up_validate: false,
    errorMessage: '',
  },
];

export const grouping = [
  {
    code: 'partner_default_field_group',
    name: 'Form Details',
    fields: [
      'customer_name_qu4p83wxh',
      'calendar_complete',
      'gst_number_0amsodvw1e',
      'sifg_payee_type_gpu8wmbsa',
      'context_input',
      'upload_photo',
    ],
  },
  {
    code: 'partner_default_field_group2',
    name: 'Form Details 2',
    fields: [
      'meeting',
      'meet_19mar_8ia9t7zqyq',
      'dob_19mar_3dat6eo56r',
      'time_19mar_gzgfe82ywi',
      'date_19mar_6odq633dvp',
    ],
  },
];

export const tableData = [
  {
    'First Name': 'Alice',
    'Last Name': 'Davis',
    Age: 22,
    Visits: 28,
    Progress: 30,
    Status: 'Single',
    State: 'LA',
  },
  {
    'First Name': 'John',
    'Last Name': 'Martinez',
    Age: 26,
    Visits: 424,
    Progress: 84,
    Status: 'Widowed',
    State: 'TX',
  },
  {
    'First Name': 'Kevin',
    'Last Name': 'Smith',
    Age: 54,
    Visits: 129,
    Progress: 24,
    Status: 'Married',
    State: 'NYC',
  },
  {
    'First Name': 'Maria',
    'Last Name': 'Johnson',
    Age: 50,
    Visits: 387,
    Progress: 25,
    Status: 'Divorced',
    State: 'LA',
  },
  {
    'First Name': 'Linda',
    'Last Name': 'Brown',
    Age: 41,
    Visits: 43,
    Progress: 66,
    Status: 'Single',
    State: 'LA',
  },
  {
    'First Name': 'Robert',
    'Last Name': 'Williams',
    Age: 75,
    Visits: 105,
    Progress: 61,
    Status: 'Married',
    State: 'NYC',
  },
  {
    'First Name': 'Barbara',
    'Last Name': 'Martinez',
    Age: 72,
    Visits: 475,
    Progress: 6,
    Status: 'Widowed',
    State: 'TX',
  },
  {
    'First Name': 'James',
    'Last Name': 'Smith',
    Age: 37,
    Visits: 174,
    Progress: 12,
    Status: 'Divorced',
    State: 'NYC',
  },
  {
    'First Name': 'Linda',
    'Last Name': 'Johnson',
    Age: 73,
    Visits: 300,
    Progress: 87,
    Status: 'Single',
    State: 'LA',
  },
  {
    'First Name': 'Patricia',
    'Last Name': 'Garcia',
    Age: 45,
    Visits: 327,
    Progress: 95,
    Status: 'Married',
    State: 'TX',
  },
  {
    'First Name': 'Alice',
    'Last Name': 'Williams',
    Age: 49,
    Visits: 236,
    Progress: 13,
    Status: 'Widowed',
    State: 'TX',
    inputsMap: {
      abc: 'aa',
    },
  },
];

export const tableCols = [
  {
    name: 'inputsMap.abc',
    type: 'string',
    canSort: true,
    defaultSort: 'desc',
  },
  {
    name: 'Last Name',
    type: 'string',
    canSort: true,
    defaultSort: '',
  },
  {
    name: 'Age',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: 'Visits',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: 'Status',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: 'State',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
  {
    name: 'Progress',
    type: 'string',
    canSort: false,
    defaultSort: '',
  },
];

export const tableRes = {
  tableName: 'Test Table',
  rows: tableData,
  metaData: {
    columnConfig: tableCols,
    groupByAttribute: 'State',
    filters: ['Status', 'Age'],
    pageSize: tableData.length,
  },
};
